import React, { useState, useEffect } from "react";
import { RouteComponentProps } from "react-router-dom";
import Header from "components/Header/index";
import LoadingWrapper from "components/LoadingWrapper/index";
import {
    Button,
    InputNumber,
    message,
    Popconfirm,
    Card,
    Breadcrumb,
    Tooltip,
    Icon
} from "antd";
import useRequest from "utils/useRequest";
import {
    getStudents,
    downloadExcel,
    getExamCourseScore,
    saveStudentDailyScore,
    exportStudentScoreList,
    setExamCourseScore
} from "service/service";
import StudentTable from "./component/studentTable/index";
import ScoreTable from "./component/scoreTable";
import Style from "./classes.module.scss";
import { useHistory } from "react-router-dom";
import { BiOutline, BiUndo, BiLinkExternal } from "react-icons/bi";
import { getNoWeekTimeCourseList, getNetCourseList } from "service/course";
interface IParams {
    courseNo: string;
    courseSeq: string;
    weekTimeId: string;
    batchNo: string;
    tab: "class" | "score";
}

interface IPageCalssesProps extends RouteComponentProps<IParams> {}

const PageClasses: React.FC<IPageCalssesProps> = ({ match }) => {
    const { goBack, push } = useHistory();
    const { courseNo, courseSeq, tab, weekTimeId, batchNo } = match.params;
    const [studentList, { loading }] = useRequest(() =>
        getStudents(courseNo, courseSeq)
    );
    const [scoreInfo, { loading: scoreInfoLoading }, getScoreInfo] = useRequest(
        () => getExamCourseScore(courseNo, courseSeq)
    );
    const [dailyScoreRate, setDailyScoreRate] = useState(0);
    const [examScoreRate, setExamScoreRate] = useState(0);
    const [courseList] = useRequest(() => getNoWeekTimeCourseList());
    const [data] = useRequest(() => getNetCourseList());
    const courseInfo = [...(data || []), ...(courseList || [])].filter(
        item => item.courseSeq === courseSeq && item.courseNo === courseNo
    )[0];

    useEffect(() => {
        if (!scoreInfo) return;
        setDailyScoreRate(parseFloat(scoreInfo.dailyScoreRate) || 0);
        setExamScoreRate(parseFloat(scoreInfo.examScoreRate) || 0);
    }, [scoreInfo]);

    const handleMergeScore = () => {
        setExamCourseScore(
            courseNo,
            courseSeq,
            `${dailyScoreRate}%`,
            `${examScoreRate}%`
        ).then(res => {
            getScoreInfo().then(res => message.success("成绩合成成功！"));
        });
    };

    const title = (
        <div>
            <Tooltip title={courseInfo?.courseName} placement="bottomLeft">
                <span className={Style.courseTitle}>
                    {courseInfo?.courseName}
                </span>
            </Tooltip>
            <Button size="small" className={Style.goBack} onClick={goBack}>
                <BiUndo size={16} />
                返回
            </Button>
        </div>
    );

    return (
        <div>
            <Header />

            <LoadingWrapper isEmpty={!studentList} loading={loading}>
                {() => (
                    <div className={Style.root}>
                        <Breadcrumb separator=">">
                            <Breadcrumb.Item href="/">首页</Breadcrumb.Item>
                            <Breadcrumb.Item>
                                <a href="">
                                    {tab === "class" ? "学员管理" : "成绩管理"}
                                </a>
                            </Breadcrumb.Item>
                        </Breadcrumb>

                        <Card
                            title={title}
                            bordered={false}
                            className={Style.container}>
                            <div className={Style.subTitle}>
                                <span>编号 {courseNo}</span>
                                <span>序号 {courseSeq}</span>
                            </div>

                            <div className={Style.content}>
                                {tab === "class" && (
                                    <>
                                        <div className={Style.contentHead}>
                                            <div className={Style.contentText}>
                                                共
                                                {studentList?.length
                                                    ? studentList?.length
                                                    : 0}
                                                人
                                            </div>
                                            <div className={Style.subButton}>
                                                {parseInt(weekTimeId) > 0 && (
                                                    <Button
                                                        className={
                                                            Style.groupBtn
                                                        }
                                                        onClick={() =>
                                                            push(
                                                                `/course/detail/${weekTimeId}/${batchNo}/${courseNo}/${courseSeq}/group/settings/class`
                                                            )
                                                        }>
                                                        <Icon type="usergroup-add" />
                                                        小组管理
                                                    </Button>
                                                )}
                                                <Button
                                                    className={Style.upload}
                                                    onClick={() =>
                                                        downloadExcel(
                                                            match.params
                                                                .courseNo,
                                                            match.params
                                                                .courseSeq
                                                        )
                                                    }>
                                                    <BiLinkExternal size={20} />
                                                    导出Excel
                                                </Button>
                                            </div>
                                        </div>
                                        <StudentTable
                                            list={studentList || []}
                                        />
                                    </>
                                )}

                                {tab === "score" && (
                                    <>
                                        <div className={Style.contentHead}>
                                            <div className={Style.subButton}>
                                                <Popconfirm
                                                    className={Style.popConfirm}
                                                    okText="确定"
                                                    cancelText="取消"
                                                    onConfirm={handleMergeScore}
                                                    title="是否要合成成绩？">
                                                    <Button>
                                                        <BiOutline size={20} />
                                                        成绩合成
                                                    </Button>
                                                </Popconfirm>
                                                <Button
                                                    className={Style.upload}
                                                    onClick={() =>
                                                        exportStudentScoreList(
                                                            courseNo,
                                                            courseSeq
                                                        )
                                                    }>
                                                    <BiLinkExternal size={20} />
                                                    导出Excel
                                                </Button>
                                            </div>

                                            <div className={Style.contentText}>
                                                共
                                                {scoreInfo?.studentScore?.length
                                                    ? scoreInfo?.studentScore
                                                          ?.length
                                                    : 0}
                                                人
                                            </div>

                                            <div
                                                className={
                                                    Style.tableHeadTools
                                                }>
                                                平时成绩占比：
                                                <InputNumber
                                                    min={0}
                                                    max={100 - examScoreRate}
                                                    onChange={value =>
                                                        setDailyScoreRate(
                                                            value || 0
                                                        )
                                                    }
                                                    value={dailyScoreRate}
                                                    placeholder="平时成绩"
                                                    formatter={value =>
                                                        `${value}%`
                                                    }
                                                    style={{ width: 100 }}
                                                    className={Style.inputNum}
                                                />
                                                考试成绩占比：
                                                <InputNumber
                                                    min={0}
                                                    max={100 - dailyScoreRate}
                                                    onChange={value =>
                                                        setExamScoreRate(
                                                            value || 0
                                                        )
                                                    }
                                                    value={examScoreRate}
                                                    placeholder="考试成绩"
                                                    formatter={value =>
                                                        `${value}%`
                                                    }
                                                    style={{ width: 100 }}
                                                    className={Style.inputNum}
                                                />
                                            </div>
                                        </div>
                                        <ScoreTable
                                            loading={scoreInfoLoading}
                                            onChange={(score, studentId) =>
                                                saveStudentDailyScore(
                                                    courseNo,
                                                    courseSeq,
                                                    studentId,
                                                    score
                                                )
                                            }
                                            list={
                                                scoreInfo
                                                    ? scoreInfo.studentScore
                                                    : []
                                            }
                                        />
                                    </>
                                )}
                            </div>
                        </Card>
                    </div>
                )}
            </LoadingWrapper>
        </div>
    );
};

export default PageClasses;
